// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".valor-total {\n  padding: 10px 10px 10px 10px;\n  font-weight: 500;\n  font-size: 26px;\n}\n.valor-total b {\n  font-size: 28px;\n  color: #008e9e;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
